import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
    getlearnfeedsRequest: ['id', 'target', 'payload', 'other', 'special', 'after'],
    getlearnfeedsSuccess: ['response'],
    getlearnfeedsFailure: null,

    postlibrarycardtemplatesRequest: ['target', 'payload', 'route'],
    postlibrarycardtemplatesSuccess: ['target', 'response'],
    postlibrarycardtemplatesFailure: null,

    getlibrarytemplatessearchRequest: ['target', 'payload', 'after'],
    getlibrarytemplatessearchSuccess: ['target', 'response'],
    getlibrarytemplatessearchFailure: null,

    getlibrarytemplatesRequest: ['target', 'payload', 'route'],
    getlibrarytemplatesSuccess: ['target', 'response'],
    getlibrarytemplatesFailure: null,

    // Deprecated saga functions, we will clean them later.
    dailytrainingRequest: ['payload'],
    dailytrainingSuccess: ['response'],
    dailytrainingFailure: null,

    updatecardRequest: ['event', 'cardId', 'page', 'perPage', 'after'],
    updatecardSuccess: null,
    updatecardFailure: null,

    getscormlinkRequest: ['courseId', 'cardId'],
    getscormlinkSuccess: ['courseId', 'cardId', 'scormLink'],
    getscormlinkFailure: null,

    postscorecardsaveRequest: ['payload'],
    postscorecardsaveSuccess: ['response'],
    postscorecardsaveFailure: null,

    updatecardinstanceRequest: ['payload'],
    updatecardinstanceSuccess: null,
    updatecardinstanceFailure: null,

    questionRequest: ['quizId'],
    questionSuccess: ['response'],
    questionFailure: null,

    answerRequest: ['quizId', 'payload'],
    answerSuccess: ['response'],
    answerFailure: null,

    resetquizRequest: ['quizId'],
    resetquizSuccess: null,
    resetquizFailure: null,

    updatemoduleRequest: ['payload'],
    updatemoduleSuccess: ['response'],
    updatemoduleFailure: null,

    librarytemplatesaveRequest: ['payload', 'files', 'target', 'after', 'route', 'callback'],
    librarytemplatesaveSuccess: ['response'],
    librarytemplatesaveFailure: null,

    librarysaveRequest: ['payload', 'image', 'pdf', 'after'],
    librarysaveSuccess: ['response', 'mode'],
    librarysaveFailure: null,

    librarycardtemplatesRequest: ['payload'],
    librarycardtemplatesSuccess: ['response'],
    librarycardtemplatesFailure: null,

    libraryeventRequest: ['target', 'event', 'id', 'data', 'route', 'after'],
    libraryeventSuccess: ['response'],
    libraryeventFailure: null,

    createquotaRequest: ['payload', 'after'],
    createquotaSuccess: ['response'],
    createquotaFailure: null,

    getquotaoptionsRequest: null,
    getquotaoptionsSuccess: ['response'],
    getquotaoptionsFailure: null,

    adddocumentRequest: ['payload', 'attachment'],
    adddocumentSuccess: ['response'],
    adddocumentFailure: null,

    deletedocumentRequest: ['payload'],
    deletedocumentSuccess: ['response'],
    deletedocumentFailure: null,

    libraryprogramdetailRequest: ['payload', 'mode', 'route'],
    libraryprogramdetailSuccess: ['response', 'mode'],
    libraryprogramdetailFailure: null,

    programeventRequest: ['payload', 'callback'],
    programeventSuccess: ['response'],
    programeventFailure: null,

    programpromotionRequest: ['payload'],
    programpromotionSuccess: ['response'],
    programpromotionFailure: null,

    quotatemplatesRequest: ['id', 'mode', 'templateIds'],
    quotatemplatesSuccess: ['id', 'mode', 'quotas'],
    quotatemplatesFailure: null,

    trainingscheduledetailRequest: ['payload'],
    trainingscheduledetailSuccess: ['response'],
    trainingscheduledetailFailure: ['response'],

    careergoalsRequest: ['id'],
    careergoalsSuccess: ['response'],
    careergoalsFailure: null,

    careergoalsaveRequest: ['id', 'data'],
    careergoalsaveSuccess: ['response'],
    careergoalsaveFailure: null,

    careerdevreportsRequest: ['companyId', 'userId'],
    careerdevreportsSuccess: ['response'],
    careerdevreportsFailure: null,

    careertasksRequest: ['userId', 'perPage', 'page'],
    careertasksSuccess: ['response'],
    careertasksFailure: null,

    careerpromoteRequest: ['companyId'],
    careerpromoteSuccess: ['response'],
    careerpromoteFailure: null,

    careercardRequest: ['payload'],
    careercardSuccess: ['response'],
    careercardFailure: null,

    careertrainingsRequest: ['userId', 'perPage', 'page'],
    careertrainingsSuccess: ['response'],
    careertrainingsFailure: null,

    adddevcommentRequest: ['payload', 'act'],
    adddevcommentSuccess: null,
    adddevcommentFailure: null,

    userscoursereportRequest: ['userId', 'dateStart', 'dateEnd'],
    userscoursereportSuccess: ['response'],
    userscoursereportFailure: null,

    teamreportsRequest: ['id', 'dateStart', 'dateEnd'],
    teamreportsSuccess: ['response'],
    teamreportsFailure: null,

    traininglistRequest: ['payload'],
    traininglistSuccess: ['response'],
    traininglistFailure: null,

    postcompanyinfoRequest: ['payload', 'companyId'],
    postcompanyinfoSuccess: ['response'],
    postcompanyinfoFailure: null,

    fetchnotificationssettingsRequest: null,
    fetchnotificationssettingsSuccess: ['response'],
    fetchnotificationssettingsFailure: null,

    updatenotificationssettingsRequest: ['payload'],
    updatenotificationssettingsSuccess: ['response'],
    updatenotificationssettingsFailure: null,

    postterminateuserRequest: ['payload', 'companyId', 'event'],
    postterminateuserSuccess: ['response'],
    postterminateuserFailure: null,

    postdeleteuserRequest: ['userId', 'companyId'],
    postdeleteuserSuccess: ['response'],
    postdeleteuserFailure: null,

    getassessmentsRequest: ['payload'],
    getassessmentsSuccess: ['response'],
    getassessmentsFailure: [null],

    getuserprogramsRequest: ['payload'],
    getuserprogramsSuccess: ['response'],
    getuserprogramsFailure: [null],

    getuserscorecardsRequest: ['payload'],
    getuserscorecardsSuccess: ['response'],
    getuserscorecardsFailure: [null],

    videostateRequest: ['cardState'],

    notificationsetRequest: ['index'],

    resetRequest: null,

    // Clearn all caches
    clearRequest: null,
});

export const DevelopTypes = Types;
export default Creators;
